import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { Inbox } from 'lucide-react';
import DispatchJobCard from './DispatchJobCard';

const DispatchUnassignedRail = ({ jobs, canDrag, isAdminView, leadsMap, selectedJobIds, onToggleSelect }) => {
  const { setNodeRef, isOver } = useDroppable({
    id: 'drop-unassigned',
    data: { type: 'unassigned-column' },
  });

  const sortedIds = jobs.map((j) => j.id);

  return (
    <div
      className={`
        flex flex-col rounded-xl border transition-colors duration-150 flex-shrink-0
        w-[260px]
        ${isOver
          ? 'border-[var(--cb-orange)] bg-[rgba(242,107,29,0.04)] shadow-md'
          : 'border-gray-200 bg-gray-50/50'
        }
      `}
      data-testid="dispatch-unassigned-rail"
    >
      {/* Header */}
      <div className="px-3 py-2.5 border-b border-gray-200 bg-white rounded-t-xl">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0">
            <Inbox className="h-3.5 w-3.5 text-gray-400" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-gray-700">Unassigned</p>
            <p className="text-[10px] text-gray-400 leading-tight">
              {jobs.length} job{jobs.length !== 1 ? 's' : ''}
            </p>
          </div>
          {jobs.length > 0 && (
            <span className="text-[10px] font-bold bg-[var(--cb-orange)] text-white px-2 py-0.5 rounded-full min-w-[20px] text-center">
              {jobs.length}
            </span>
          )}
        </div>
      </div>

      {/* Job list */}
      <div
        ref={setNodeRef}
        className="flex-1 p-2 space-y-2 min-h-[80px] overflow-y-auto max-h-[calc(100vh-260px)]"
        data-testid="dispatch-unassigned-jobs"
      >
        {isOver && (
          <div className="border-2 border-dashed border-[var(--cb-orange)] rounded-lg p-3 text-center text-[11px] text-[var(--cb-orange)]">
            Drop here to unassign
          </div>
        )}

        <SortableContext items={sortedIds} strategy={verticalListSortingStrategy}>
          {jobs.map((job) => (
            <DispatchJobCard
              key={job.id}
              task={job}
              lead={leadsMap[job.leadId]}
              canDrag={canDrag && isAdminView}
              canChangeStatus={isAdminView}
              isSelected={selectedJobIds?.has(job.id)}
              onToggleSelect={onToggleSelect}
            />
          ))}
        </SortableContext>

        {jobs.length === 0 && !isOver && (
          <p className="text-[11px] text-gray-400 text-center py-4">
            All jobs assigned
          </p>
        )}
      </div>

      {/* Footer hint */}
      {isAdminView && (
        <div className="border-t border-gray-100 px-2 py-1.5 bg-white rounded-b-xl">
          <p className="text-[10px] text-gray-400 text-center">
            Drag jobs to a technician column
          </p>
        </div>
      )}
    </div>
  );
};

export default DispatchUnassignedRail;
